@import "../../../../../styles/variables";
:host {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
}

:host(.has-chips) {
  position: relative;
  &:after {
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    width: 10px;
    height: 100%;
    z-index: 0;
    background-color: $svs-white;
    border-right: 1px solid $svs-super-light-grey;
  }
  &:before {
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    width: 1px;
    height: 100%;
    z-index: 0;
    box-shadow: 0 0 10px $svs-black;
  }
}

.bc-label {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 12px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;

  &.bold-label {
    font-weight: 700;
    font-size: 18px;
    line-height: 30px;
  }
}

.bc-counter {
  display: none;
  align-items: center;
  justify-content: center;
  height: 20px;
  min-width: 20px;
  padding: 2px;
  border-radius: 42px;
  background-color: $svs-se-life-green;
  color: $svs-white;
  font-size: 12px;
  z-index: 1;
  margin-right: 8px;

  &.visible {
    display: flex;
  }

  &.more-padding {
    padding: 2px 4px;
  }
}
